import { SelectedDelivery } from 'public/context/CartContext';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { FarmDeliveries, OpenHours } from 'types/FarmData';
import { safeJSONParse } from 'utils/generalHelpers';
import { parseOpenHours } from 'utils/productCardHelpers';
import { StyledSelfDelivery } from '../style';

interface SelfDeliveryProps {
  selectedDelivery: FarmDeliveries;
  setSelectedDeliveryData: React.Dispatch<
    React.SetStateAction<SelectedDelivery[] | null>
  >;
  selectedDeliveryData: SelectedDelivery[] | null;
}

const SelfDelivery = ({
  selectedDelivery,
  setSelectedDeliveryData,
  selectedDeliveryData,
}: SelfDeliveryProps) => {
  const intl = useIntl();

  useEffect(() => {
    setSelectedDeliveryData([
      ...(selectedDeliveryData || []),
      {
        id: undefined,
        selectedDeliveryId: selectedDelivery.id,
        city: undefined,
        address: selectedDelivery.address,
        firm_name: selectedDelivery?.type,
        name: selectedDelivery.name,
        price: selectedDelivery.price,
      },
    ]);
  }, []);

  return (
    <StyledSelfDelivery>
      <div className={'delivery'}>
        <div className={'content'}>
          <div className={'address'}>
            {selectedDelivery && selectedDelivery.address}
          </div>
          <div className={'phone-number'}>
            {selectedDelivery.phone}
          </div>
          <table className="open-hours-table">
            <tbody>
              {selectedDelivery?.open_hours &&
                parseOpenHours(safeJSONParse<OpenHours[]>(selectedDelivery?.open_hours, [])).map(
                  (hours, index) => (
                    <tr
                      key={index}
                      className={
                        index && index % 2 === 1
                          ? 'light-gray-background'
                          : 'white-background'
                      }
                    >
                      <td className={'td-day'}>
                        {intl?.formatMessage({ id: `open_hours.${hours.day}` })}
                      </td>
                      <td>
                        {hours.from !== 'Closed'
                          ? hours.from + ' - ' + hours.to
                          : ''}
                      </td>
                    </tr>
                  ),
                )}
            </tbody>
          </table>
        </div>
      </div>
    </StyledSelfDelivery>
  );
};

export default SelfDelivery;
